import styled from 'styled-components';
import Button from '@nebula/button';

export const Container = styled.main`
  height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 49px)')};
  min-height: 667px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  background: ${props => props.theme.color.ui.white};
  width: 100%;
  gap: 24px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 80px)')};
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 84px)')};
  }
`;

export const ErrorState = styled.div`
  background: ${props => props.theme.color.brand.white};
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  @media ${({ theme }) => theme.media.smallMobileMin} {
    width: 375px;
  }
  @media ${({ theme }) => theme.media.mobileMin} {
    width: 485px;
  }
`;

export const InfoIconContainer = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))``;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
`;

export const Heading = styled.h1`
  color: ${props => props.theme.color.ui.grey[100]};
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
`;

export const SubHeading = styled.p`
  color: ${props => props.theme.color.ui.grey[90]};
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;

export const TryAgainButton = styled(Button)`
  display: flex;
  height: 48px;
  padding: 8.5px 24px;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 6px;
  background: ${props => props.theme.color.decorative.magenta[70]};
  color: ${props => props.theme.color.brand.white};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  &:hover {
    background: ${props => props.theme.color.decorative.magenta[70]};
  }
  margin-top: 16px;
`;
